module.exports = __webpack_public_path__ + "static/media/reset-button-disabled.4d34b6aa.svg";